import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import translations from './translations/messages.js'
import VueCookies from 'vue-cookies'

var messages = translations;
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'pl', // set locale
  messages, // set locale messages
})


window.$ = window.jQuery = require('jquery');
Vue.config.productionTip = false

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

Vue.use(VueCookies);

new Vue({
  render: h => h(App),
  i18n
}).$mount('#app')
